module.exports = __webpack_public_path__ + "static/media/add_weld_1.c14d6874.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/add_weld_1.jpg
// module id = 1858
// module chunks = 0